import React, { FC, useState } from 'react'
import { ReactComponent as FaxIcon } from 'src/assets/fax.svg'
import { Text } from 'src/modules//components/lib/text'
import { Button } from 'src/modules/components/lib/button'
import { Heading } from 'src/modules/components/lib/heading'
import { Loader } from 'src/modules/components/lib/loader'
import { Modal } from 'src/modules/components/lib/modal'
import { Screen } from 'src/modules/components/lib/screen'
import { Flexbox, View } from 'src/modules/components/lib/view'
import { PharmacyForFreeDelivery } from 'src/modules/entities/pharmacy/entity'
import { Footer } from 'src/modules/screens/top/footer'
import { PharmacyList } from './pharmacy-list'

type Props = {
  nearestFreeDeliveryPharmacy: PharmacyForFreeDelivery | null
  pharmacies?: PharmacyForFreeDelivery[]
  isLoading: boolean
}
export const NetApplicationFreeDeliverySearchScreen: FC<Props> = ({
  nearestFreeDeliveryPharmacy,
  pharmacies,
  isLoading,
}) => {
  const [selectedPharmacy, setSelectedPharmacy] =
    useState<PharmacyForFreeDelivery | null>(null)

  return (
    <Screen>
      <View backgroundColor="appBackground" px="16px" height="100%" py="20px">
        <Heading fontSize={'18px'} color={'#2B323B'} pb={'8px'}>
          薬局を選ぶ
        </Heading>
        <Text mb={4}>
          オンライン服薬指導を受けたい薬局を選び、診察先の医療機関へお伝えください。
        </Text>

        {isLoading ? (
          <Flexbox justifyContent="center" alignItems="center" width="100%">
            <Loader py={8} />
          </Flexbox>
        ) : (
          pharmacies && (
            <PharmacyList
              nearestFreeDeliveryPharmacy={nearestFreeDeliveryPharmacy}
              pharmacies={pharmacies}
              onSelect={setSelectedPharmacy}
            />
          )
        )}
      </View>
      <Modal visible={!!selectedPharmacy} showCloseButton={false}>
        <View px={5}>
          <Text
            fontWeight={'bold'}
            textAlign={'left'}
            bg={'#E7F4FD'}
            py={3}
            px={4}
            mb={6}
            border={'1px solid #A1D5F7'}
          >
            以下の情報を診察先の医療機関にお伝えください。
          </Text>
          <Text mb={2} fontSize={'18px'} fontWeight={'bold'} textAlign={'left'}>
            {selectedPharmacy?.name}
          </Text>
          <Flexbox fontWeight={'bold'} alignItems={'center'} mb={6}>
            <FaxIcon />
            <View mx={2}>FAX</View>
            <View fontSize={'18px'}>{selectedPharmacy?.fax}</View>
          </Flexbox>
          <Button shape={'square'} onClick={() => setSelectedPharmacy(null)}>
            閉じる
          </Button>
        </View>
      </Modal>
      <Footer />
    </Screen>
  )
}
